import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { useHistory } from "react-router-dom";
import { getDashboard } from '../../helpers/backend';





const Widget2 = props => {
    const history = useHistory()
    const user = JSON.parse(localStorage.getItem("user"));
    const groups =String(user.groups);

    const [dashboardList,  setDashboardList] = useState({})
    
        const getData = async () => {
            const response = await getDashboard();
            const data = response.data;
            setDashboardList(data)
        };

useEffect(() => {
    getData();
}, [])

const widget2 = [
{   id: 1,
    title: 'Usuarios por Vincular',
    count: dashboardList.por_vincular,
    icon: ' fas fa-user-clock text-danger ',
    path:'users/user_por_vincular',
    color: "#f2dfdf"
}
]
const por_vincular = dashboardList.por_vincular
const redirect = (path) => {
    history.push(`${path}`)
  };
    return (
        <React.Fragment>
            <Row>
            {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") ? (
            por_vincular ? (
                widget2.map((widget, key) => (
                    <Col lg={12} key={key}>
                        <Card style={{cursor: 'pointer', height: '140px', background: widget.color}} onClick={()=>redirect(widget.path) }>

                            <CardBody>
                                <div className="float-end">
                                    <div className="avatar-sm mx-auto mb-4">
                                        <span className="avatar-title rounded-circle bg-light font-size-24">
                                            <i className={widget.icon}></i>
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <p className=" text-uppercase fw-semibold font-size-18 " ><b>{widget.title}</b> </p>
                                    <h3 className="mb-1 mt-1">
                                        <span className="counter-value" data-target="58425">
                                            {widget.count}
                                        </span></h3>
                                </div>

                            </CardBody>
                        </Card>
                    </Col>
                ))
            ): null
        ):null }
            </Row>
        </React.Fragment>
    );
}

export default Widget2;